import { Card, Image, Tag } from 'antd';
import React from 'react';

const RackMasterInventoryCard = ({
  record,
  infiniteScrollRef,
  setVisible,
  setToyImages,
}) => (
  <Card
    ref={infiniteScrollRef}
    className="ml-12 mr-12 mb-24 mt-12 mobile-card"
    title={
      <div className="overflow-scroll no-scroll-bar">{record?.toy?.name}</div>
    }
    extra={
      <div className="d-flex align-center">
        <span className="mr-16 ml-16">
          {record?.toy?.images?.length > 0 && (
            <>
              <Image
                preview={{
                  visible: false,
                }}
                width={20}
                height={20}
                src={record?.toy?.images?.[0]?.url}
                onClick={(e) => {
                  e?.stopPropagation();
                  setVisible(true);
                  setToyImages(record?.toy?.images);
                }}
                className="pointer"
              />
            </>
          )}
          {record?.toy?.images?.length > 1
            ? ` + ${record?.toy?.images?.length - 1}`
            : ''}
        </span>
      </div>
    }
  >
    <div>
      <div className="mb-8">
        <span className="mobile-card-label">Product Name: </span>
        <span>{record?.toy?.name || 'No Product Name'}</span>{' '}
        <span>{record?.toy?.toyNumber && `(${record?.toy?.toyNumber})`}</span>
      </div>
      <div className="mb-8">
        <span className="mobile-card-label">Brand: </span>
        <span>{record?.toy?.brand?.name || 'No Brand found'}</span>
      </div>

      <div className="mb-8">
        <span className="mobile-card-label">Categories: </span>
        <span>
          {record?.toy?.categories?.length > 0
            ? record?.toy?.categories?.map((category) => (
                <Tag key={category?.id}>{category?.name}</Tag>
              ))
            : 'No Categories found'}
        </span>
      </div>
      <div className="mb-8">
        <span className="mobile-card-label">Material: </span>
        <span>{record?.toy?.material?.name || 'No material found'}</span>
      </div>
      <div className="mb-8">
        <span className="mobile-card-label">Age Group: </span>
        <span>
          {record?.toy?.ageGroups?.length > 0
            ? record?.toy?.ageGroups?.map((ageGroup) =>
                ageGroup?.minAge > 18 ? (
                  <Tag key={ageGroup?.id}>
                    {Math.floor(ageGroup?.minAge / 12)} -{' '}
                    {Math.floor(ageGroup?.maxAge / 12)} Years
                  </Tag>
                ) : (
                  <Tag key={ageGroup?.id}>
                    {ageGroup?.minAge} - {ageGroup?.maxAge} Months
                  </Tag>
                ),
              )
            : 'No Age Group found'}
        </span>
      </div>
      <div className="mb-8">
        <span className="mobile-card-label">Facilitates: </span>
        <span>
          {record?.toy?.facilitates?.length > 0
            ? record?.toy?.facilitates?.map((facilitate) => (
                <Tag key={facilitate?.id}>
                  {facilitate?.name?.replace(/\s/g, '\u00a0')}
                </Tag>
              ))
            : 'No Facilitates found'}
        </span>
      </div>

      <div className="mb-8">
        <span className="mobile-card-label">Tags: </span>
        <span>
          {record?.toy?.tags?.length > 0
            ? record?.toy?.tags?.map((tag) => (
                <Tag key={tag?.id}>{tag?.name?.replace(/\s/g, '\u00a0')}</Tag>
              ))
            : 'No Tags found'}
        </span>
      </div>
    </div>
  </Card>
);

export default RackMasterInventoryCard;
